
window.onYouTubeIframeAPIReady = function() {
	movie.id = document.querySelector("#player").getAttribute("data-id");
	//console.log("YouTube API is Ready");
	movie.setPlayer();
}
export let movie = {
	id: "",
	player: null,
	timer: null,
	isLoaded: false,
	init: function(){
		let tag = document.createElement('script');
		
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		
		/*
		window.addEventListener('focus', function(){
			if(movie.isLoaded && movie.status != 1){
				if(movie.player){
					movie.player.playVideo();
				}
			}
		});
		*/
	},
	setPlayer: function(){
		movie.player = new YT.Player('player', {
			height: '360',
			width: '640',
			videoId: movie.id,
			playerVars 	: {
				autohide	: 1,
				controls	: 1,
				frameborder : 0,
				rel			: 0,
				start		: 0,
				showinfo 	: 0,
				disablekb	: 1,
				wmode		: "transparent",
				autoplay	: 0,
				mute 		: 1,
				playsinline	: 1,
				enablejsapi	: 1,
				iv_load_policy: 3,
				origin: location.protocol + '//' + location.hostname + "/"
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		});
		function onPlayerReady(e){
			//console.log("player ready:", e, " ---------------------------------------------------");
			movie.player = e.target;
			movie.player.stopVideo();
			movie.status = e;
			movie.isLoaded = true;
		}
		function onPlayerStateChange(e){
			//console.log("state:", e);
			movie.status = e.data;
			if(e.data === 1){
				//console.log("再生開始");
			}else if(e.data === 2){
				//console.log("再生停止")
			}
		}
	},
	playVideo: function(){
		//console.log("play video", movie.status, movie.isLoaded);
		if(movie.status === 1){
			return false
		}else{
			movie.player.playVideo();
			clearInterval(movie.timer);
			movie.timer = setInterval(function(){
				let c = movie.player.getCurrentTime();
				//let e = 7;
				let e = movie.player.getDuration();
				//console.log(c, e);
				if(c >= e){
					movie.player.seekTo(0);
				}
			}, 100);
		}
	}
}